import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  numberAttribute,
} from '@angular/core';

import { IconName } from './auto-generated/icon-name';
import { outlinedIconNames } from './auto-generated/outlined-icon-names';

@Component({
  selector: 'mop-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.min-width.px]': 'size()',
    '[style.width.px]': 'size()',
    '[style.max-width.px]': 'size()',
    '[style.min-height.px]': 'size()',
    '[style.height.px]': 'size()',
    '[style.max-height.px]': 'size()',
  },
})
export class IconComponent {
  name = input.required<IconName>();
  size = input(24, { transform: numberAttribute });
  outlined = input(false, { transform: booleanAttribute });

  href = computed(() => {
    const set =
      this.outlined() && outlinedIconNames.has(this.name())
        ? 'modus-outlined'
        : 'transportation';
    return `/assets/mop-icons/${set}/modus-icons.svg#${this.name()}`;
  });
}
